module.exports = __webpack_public_path__ + "static/media/iconClock.4bba00b9.svg";